import { useEffect, useState } from 'react'
import confetti from 'canvas-confetti'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation2({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    // Pluie de confettis du haut
    const duration = 4000
    const animationEnd = Date.now() + duration
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 }

    function randomInRange(min: number, max: number) {
      return Math.random() * (max - min) + min
    }

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now()

      if (timeLeft <= 0) {
        return clearInterval(interval)
      }

      const particleCount = 50 * (timeLeft / duration)

      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        colors: ['#0F352D', '#1d5c4d', '#FFF198', '#feee80', '#fcf5cc']
      })
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        colors: ['#0F352D', '#1d5c4d', '#FFF198', '#feee80', '#fcf5cc']
      })
    }, 250)

    setTimeout(() => setShowBadge(true), 300)

    return () => clearInterval(interval)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        <div className={`transition-all duration-1000 ${showBadge ? 'translate-y-0 opacity-100' : '-translate-y-20 opacity-0'}`}>
          {/* Badge */}
          <div className="w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 mb-6">
            <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
          </div>

          {/* Nom du badge */}
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow text-center drop-shadow-[0_0_30px_rgba(255,241,152,0.5)]">
            {badge.name}
          </div>

          {/* Points */}
          <div className="text-lg sm:text-xl text-tessan-cream text-center mt-2">
            +{badge.points_awarded} points
          </div>

          {/* Description */}
          <div className="text-tessan-cream/70 text-center mt-4 max-w-[280px] sm:max-w-xs">
            {badge.description}
          </div>
        </div>
      </div>
    </AnimationLayout>
  )
}
